import type {CreateExtArgs} from '@wix/document-manager-core'
import type {CompRef, DependenciesManager} from '@wix/document-services-types'
import type {DependencyMatcher} from './types'
import {breakpointsMatcher} from './breakpoints'

const defaultMatchers: DependencyMatcher[] = [breakpointsMatcher]

export const applyMatchers = (
    extensionContext: CreateExtArgs,
    componentToReplace: CompRef,
    dependenciesManager: DependenciesManager
): void => {
    for (const matcher of defaultMatchers) {
        matcher.match(extensionContext, dependenciesManager, componentToReplace)
    }
}
